export const LAST_WORKSPACE = '_lastWorkspace';

export const setLastWorkspace = (v: string) =>
  window.localStorage.setItem(LAST_WORKSPACE, v);
export const getLastWorkspace = () =>
  window.localStorage.getItem(LAST_WORKSPACE);
